/******************************************************************************
 * GENERATED by scripts/generateHooks.ts — DO NOT EDIT.
 * Re-run with `pnpm zen3:generate`.
 ******************************************************************************/

/* eslint-disable */

import { useModelQueries, type ModelQueryHooks } from '@zenstackhq/tanstack-query/react';
import { schema } from '../zen3/schema-lite';

type Hooks = ModelQueryHooks<typeof schema, 'SettingValue'>;
const hooks = useModelQueries(schema, 'SettingValue');

export const useAggregateSettingValue: Hooks['useAggregate'] = hooks.useAggregate;
export const useCountSettingValue: Hooks['useCount'] = hooks.useCount;
export const useCreateSettingValue: Hooks['useCreate'] = hooks.useCreate;
export const useCreateManySettingValue: Hooks['useCreateMany'] = hooks.useCreateMany;
export const useCreateManyAndReturnSettingValue: Hooks['useCreateManyAndReturn'] = hooks.useCreateManyAndReturn;
export const useDeleteSettingValue: Hooks['useDelete'] = hooks.useDelete;
export const useDeleteManySettingValue: Hooks['useDeleteMany'] = hooks.useDeleteMany;
export const useExistsSettingValue: Hooks['useExists'] = hooks.useExists;
export const useFindFirstSettingValue: Hooks['useFindFirst'] = hooks.useFindFirst;
export const useFindManySettingValue: Hooks['useFindMany'] = hooks.useFindMany;
export const useFindUniqueSettingValue: Hooks['useFindUnique'] = hooks.useFindUnique;
export const useGroupBySettingValue: Hooks['useGroupBy'] = hooks.useGroupBy;
export const useInfiniteFindManySettingValue: Hooks['useInfiniteFindMany'] = hooks.useInfiniteFindMany;
export const useSuspenseAggregateSettingValue: Hooks['useSuspenseAggregate'] = hooks.useSuspenseAggregate;
export const useSuspenseCountSettingValue: Hooks['useSuspenseCount'] = hooks.useSuspenseCount;
export const useSuspenseFindFirstSettingValue: Hooks['useSuspenseFindFirst'] = hooks.useSuspenseFindFirst;
export const useSuspenseFindManySettingValue: Hooks['useSuspenseFindMany'] = hooks.useSuspenseFindMany;
export const useSuspenseFindUniqueSettingValue: Hooks['useSuspenseFindUnique'] = hooks.useSuspenseFindUnique;
export const useSuspenseGroupBySettingValue: Hooks['useSuspenseGroupBy'] = hooks.useSuspenseGroupBy;
export const useSuspenseInfiniteFindManySettingValue: Hooks['useSuspenseInfiniteFindMany'] = hooks.useSuspenseInfiniteFindMany;
export const useUpdateSettingValue: Hooks['useUpdate'] = hooks.useUpdate;
export const useUpdateManySettingValue: Hooks['useUpdateMany'] = hooks.useUpdateMany;
export const useUpdateManyAndReturnSettingValue: Hooks['useUpdateManyAndReturn'] = hooks.useUpdateManyAndReturn;
export const useUpsertSettingValue: Hooks['useUpsert'] = hooks.useUpsert;
